<g-global-styles></g-global-styles>
<router-outlet></router-outlet>
